module.exports = __webpack_public_path__ + "static/media/PPIA University of Melbourne.df4a20ab.png";